const SCROLL_ANIMATION_STEPS = 10;
const SCROLL_ANIMATION_INTERVAL = 10;

export function animateHintScroll(target: HTMLElement, scrollContainerClass: string = '.dlb-wrap') {
    window.requestAnimationFrame(() => {
        const topPosition = target.offsetTop;
        const wrap = document.querySelector(scrollContainerClass);
        if (wrap && topPosition) {
            let step = 0;
            const timer = setInterval(() => {
                wrap.scrollTop = (step * topPosition) / SCROLL_ANIMATION_STEPS;
                step += 1;
                if (step === SCROLL_ANIMATION_STEPS) clearInterval(timer);
            }, SCROLL_ANIMATION_INTERVAL);
        }
    });
}
